module.exports = __webpack_public_path__ + "static/media/Relative-Medium-Web.f7bfab61.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Relative-Medium-Web.woff
// module id = 748
// module chunks = 0